class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;
    // Allow default link behavior to /cart instead of opening drawer
    // cartLink.setAttribute('role', 'button');
    // cartLink.setAttribute('aria-haspopup', 'dialog');
    // cartLink.addEventListener('click', (event) => {
    //   event.preventDefault();
    //   this.open(cartLink);
    // });
    // cartLink.addEventListener('keydown', (event) => {
    //   if (event.code.toUpperCase() === 'SPACE') {
    //     event.preventDefault();
    //     this.open(cartLink);
    //   }
    // });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
    this.querySelector("information-popup[open]")?.removeAttribute("open");
    this.querySelector(".quick-add_content").classList.remove("open");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.classList.contains("is-empty") && this.classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

// Mouseover Function for Quick Add Buttons of Product Card
function setSellingPlanQuickAddValue(event) {
  let product_card = event.target.closest(".product-card-wrapper");
  let selling_plan_input = product_card.querySelector(
    "input[name='selling_plan']",
  );
  let sub_is_selected = false;

  if (
    document.querySelector("cart-selling-plan-select .recurring:checked") &&
    !document.querySelector("cart-drawer.is-empty")
  ) {
    sub_is_selected = true;
  }
  if (product_card.dataset.sellingPlanIds != "" && sub_is_selected) {
    let selected_plan = document.querySelector(
      "cart-selling-plan-select .selling_plan-select",
    ).value;
    selling_plan_input.value =
      product_card.dataset.sellingPlanIds.split(",")[selected_plan];
  } else {
    selling_plan_input.value = "";
  }
}

class specialProduct extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector("input[type='checkbox']");
    this.checkbox.addEventListener("change", this.onCheckboxChange.bind(this));
    this.cart = this.closest("cart-drawer");
    this.addArray = [{ id: this.dataset.variantId, quantity: 1 }];
    if (this.querySelector(".special-product--popup-wrapper")) {
      this.querySelector(
        ".special-product--information-wrapper .special-product--title",
      ).addEventListener("click", this.openPopup.bind(this));
      this.querySelector(".special-product--popup-wrapper").addEventListener(
        "click",
        this.closePopup.bind(this),
      );
    }
  }
  onCheckboxChange(event) {
    event.stopPropagation();
    if (this.checkbox.checked) {
      this.add();
    } else {
      this.remove();
    }
  }
  add() {
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: this.addArray,
        sections: this.cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.cart.renderContents(parsedState);
      });
  }
  remove() {
    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: this.dataset.variantId,
        quantity: 0,
        sections: this.cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.cart.renderContents(parsedState);
      });
  }
  openPopup() {
    this.setAttribute("show-popup", "");
  }
  closePopup(event) {
    if (!event.target.closest(".special-product--popup")) {
      this.removeAttribute("show-popup");
    }
  }
}
customElements.define("special-product", specialProduct);

class infoMaterial extends specialProduct {
  constructor() {
    super();
    this.addArray = [];
    this.querySelectorAll(
      ".info-material--products-data .info--material.available",
    ).forEach((info) => {
      let addObject = { id: info.dataset.variantId, quantity: 1 };
      this.addArray.push(addObject);
    });
    this.deleteObject = {};
    this.querySelectorAll(
      ".info-material--products-data .info--material",
    ).forEach((info) => {
      this.deleteObject[info.dataset.variantId] = 0;
    });
    // console.log("delete_array",this.deleteArray)
  }
  remove() {
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: this.deleteObject,

        sections: this.cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.cart.renderContents(parsedState);
      });
  }
}

customElements.define("info-material", infoMaterial);
